import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { fromEvent } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { setOpenedTasks } from '@/app/_infrastructure/adapters/store/opened-tasks/opened-tasks.actions';
import { setSessionRefresh } from '@/app/_infrastructure/adapters/store/session-refresh/session-refresh.actions';
import { setUser, deleteUser } from '@/app/_infrastructure/adapters/store/user/user.actions';
import { setUserPrefs } from '@/app/_infrastructure/adapters/store/user-prefs/user-prefs.actions';

@Injectable()
export class AppStateEffects {
  onChange = createEffect(
    () =>
      fromEvent<StorageEvent>(window, 'storage').pipe(
        filter((evt) => evt.key === 'sessionRefresh' || evt.key === 'user' || evt.key === 'userPrefs' || evt.key === 'openedTasks'),
        filter((evt) => evt.newValue !== null && evt.oldValue !== evt.newValue),
        map((evt) => {
          console.log('Actualización de datos de la pestaña desde el localstorage', evt);
          const newValue = JSON.parse(evt.newValue);
          switch (evt.key) {
            case 'openedTasks':
              // State is now wrapped in { openedTasks: [...] }
              const tasks = newValue.openedTasks || newValue; // Handle both just in case
              return setOpenedTasks({ tasks, avoidPersistence: true });
            case 'user':
              if (!newValue?.accessToken) {
                return deleteUser();
              } else {
                return setUser({ sessionInfo: newValue, avoidPersistence: true });
              }
            case 'userPrefs':
              return setUserPrefs({ userPrefs: newValue, avoidPersistence: true });
            case 'sessionRefresh':
              return setSessionRefresh({ state: newValue, avoidPersistence: true });
          }
        })
      ),
    { dispatch: true }
  );

  constructor(private actions$: Actions) {}
}
